import { DatePipe } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../_services/app.service';
import { CommonService } from '../_services/common.service';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from '../theme/home/translateConfig.service';
import { Helpers } from '../helpers';
import { PrintFormatsComponent } from '../print-formats/print-formats.component';
import { HttpClient } from '@angular/common/http';
declare var $: any;
const LNG_KEY = "SELECTED_LANGUAGE";
@Component({
  selector: 'app-print-formats-new',
  templateUrl: './print-formats-new.component.html',
  styleUrls: ['./print-formats-new.component.scss']
})
export class PrintFormatsNewComponent implements OnInit, AfterViewInit {


  hostURL = environment.apiUrl;
  hostUrl = environment.apiUrl;
  static that: PrintFormatsNewComponent;

  selectedLang: string;
  imgPath: any;
  CompanyId: any;
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  HeadBranchGST: any;
  HeadBranchCIN: any;
  SelectedCompanyLogo: any;
  TenantId: any;
  TermsAndCondition: any;
  TermsandConditions: any;
  UseManualLRNumberFlag: any = false;
  SelectedCompanyHeadAdd: any;
  SelectedCompanyWebsite: any;

  ConsignmentsData: any = [];
  LorryReceiptData: any = [];
  ConsignmentsData4: any = [];
  dataLoaded = false;
  LorryReceiptPrint2 = false;
  ConsignmentNote_2 = [1, 2, 3];
  ConsignmentNote_3 = [1, 2, 3, 4];
  ShipmentModeName: any;
  SelectedCompantEmail: any;
  SelectedCompanyPAN: any;
  containerNo: any;
  sealNo: any;

  @ViewChild(PrintFormatsComponent) PrintFormatsChild: PrintFormatsComponent;
  PrintQuoteData: any = [];
  InvoiceData: any = [];
  QuoteCompanyData: any;
  QuoteUserData: any;
  quoteCompanyEmail = '';
  quoteUserName = '';
  quoteUserEmail = '';
  quoteUserPhone = '';
  companyName = '';
  OrderId: any;
  ExpenseId: any;//added by BURHAN - 13-feb-2026
  InvoiceId: any;//added by BURHAN - 19-Feb-2026
  UserId: any;
  //added by BURHAN - 23-Feb-2026
  OrderDetails: any = [];
  OrderListDetails: any = [];
  Payments: any = {};
  CalculatedAmounts: any = [];

  //end by BURHAN

  // Added by priya - 10/01/2026
  BookingId: any;
  OrderData: any = [];
  TripData: any = [];
  TripIncomeExpenseData: any = [];
  IsPrintTripProfibility: boolean = false;
  IsPrintCashExpenseData: boolean = false; //Added by BURHAN - 18-Feb-2026
  divElements: any = "";
  @Output() renderComplete = new EventEmitter<void>();
  ExpenseVoucherData: any = []; // Added by priya - 12/02/2026 - cn(PRIYA-FEB26-003)
  IsPrintExpenseVoucher: boolean = false; // Added by priya - 12/02/2026 - cn(PRIYA-FEB26-003)
  IsPrintReceiptVoucher: boolean = false; // Added by Burhan - 23-Feb-2026
  IsPrintPaymentMadeVoucher: boolean = false; // Added by Burhan - 23-Feb-2026
  IsPrintPaymentVoucher: boolean = false; // Added by Burhan - 23-Feb-2026
  TenantUsers: any; // Added by priya - 24/02/2026 - cn(PRIYA-FEB26-005)
  SelectedCompanyLogoImg: any; // Added by priya - 24/02/2026 - cn(PRIYA-FEB26-005)
  ParentCompanyName: any; // Added by priya - 24/02/2026 - cn(PRIYA-FEB26-005)
  BillId: any; // Added by priya - 24/02/2026 - cn(PRIYA-FEB26-005)
  ReportType: any; // Added by priya - 24/02/2026 - cn(PRIYA-FEB26-005)
  PrintBillData: any = []; // Added by priya - 24/02/2026 - cn(PRIYA-FEB26-005)
  IsPrintDetailBill: boolean = false; // Added by priya - 24/02/2026 - cn(PRIYA-FEB26-005)
  GatePassData: any = {};
  IsPrintGatePass: boolean = false;
  PalletNo: any;
  PalletSlipHeader: any = [];
  PalletSlipDetails: any = [];
  IsPrintPalletSlip: boolean = false;

  isPrintJournalEntry: boolean = false;  // Added by fahim - 02/03/2026 
  PrintJournalEntryData: any;
  PrintVoucherNo: any;
  PrintPostingDate: any;
  PrintAddress: any;
  PrintDescription: any;
  PrintJEType: any;
  PrintReferenceDate: any;
  PrintReferenceNo: any;
  totalDebit = 0;
  totalCredit = 0;

  InvoiceNo: any;
  ConsignmentDetailId: any;
  CompanyPhone: any;
  CompanyDescription: any;
  TermsandConditionsLR: any;
  IsFtlMarkedContainerPicked: boolean = false;

  constructor(
    private _script: ScriptLoaderService,
    private _appService: appService,
    private commonService: CommonService,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    private cookieservice: CookieService,
    private translate: TranslateService,
    private service: TranslateConfigService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private http: HttpClient,
  ) {
    PrintFormatsNewComponent.that = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.SelectedComapnyName = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedComapnyName;
    this.SelectedCompanyAdd = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyAdd;
    this.SelectedCompanyCIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompanyCIN;
    this.SelectedCompantGSTIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).SelectedCompantGSTIN;
    this.HeadBranchGST = JSON.parse(localStorage.getItem("ChnageCompnayId")).HeadBranchGST;
    this.HeadBranchCIN = JSON.parse(localStorage.getItem("ChnageCompnayId")).HeadBranchCIN;
    this.SelectedCompanyLogo = JSON.parse(localStorage.getItem("ChnageCompnayId")).CompanyLogoPath;
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.TermsAndCondition = JSON.parse(localStorage.getItem("ChnageCompnayId")).TermsAndConditions;
    this.UseManualLRNumberFlag = JSON.parse(localStorage.getItem("UseManualLRNumberFlag"));
    this.SelectedCompanyHeadAdd = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyHeadAdd;
    this.SelectedCompanyWebsite = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).Website;
    this.SelectedCompantEmail = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedComapnyEmail;
    this.SelectedCompanyPAN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyPAN;
    this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
    // Added by priya - 29/07/2026 - cn(PRIYA-JUL26-018)
    let FtlMarkedContainerPicked = localStorage.getItem("IsFtlMarkedContainerPicked")
    this.IsFtlMarkedContainerPicked = FtlMarkedContainerPicked == '1' ? true : false;
  }

  PrintDropdownSelecteData(item, row) {
    this.GetTermsAndConditions();

    if (item.Code == 0 || item.Code == '0') {
      this.GetLorryReceiptPrint(row.ConsignmentNoteId);
    }
    else if (item.Code == 1 || item.Code == '1') {
      PrintFormatsNewComponent.that.ShipmentModeName = row.ShipmentModeName;
      // this.GetLorryReceiptPrint1(row.ConsignmentNoteId);
      this.GetLorryReceiptPrint2(row.ConsignmentNoteId, row.BookingId);
    }
    else if (item.Code == 2 || item.Code == '2') {
      this.GetLorryReceiptPrint3(row.ConsignmentNoteId, row.BookingId);
    }
    else if (item.Code == 3 || item.Code == '3') {
      PrintFormatsNewComponent.that.PrintFormatsChild.InvoiceType = 'PrintLorryReceipt4';
      PrintFormatsNewComponent.that.PrintFormatsChild.From = 'Destination';
      PrintFormatsNewComponent.that.PrintFormatsChild.ConsignmentNoteId = row.ConsignmentNoteId;
      PrintFormatsNewComponent.that.PrintFormatsChild.CompId = PrintFormatsNewComponent.that.CompanyId;
      $("#PrintInvoice").val("");
      PrintFormatsNewComponent.that.PrintFormatsChild.PrintInvoice();
    }
    else {
      console.log("sabka malik ek!");
    }
  }

  PrintDropdownData(item, row) {
    
    this.GetTermsAndConditions();
    // Added by priya - 29/07/2026 - cn(PRIYA-JUL26-018)
    if (item === 'Print Lorry Receipt' && this.IsFtlMarkedContainerPicked) {
      PrintFormatsNewComponent.that.ShipmentModeName = row.ShipmentModeName;
      this.GetLorryReceiptPrint2(row.ConsignmentNoteId, row.BookingId);
    }
    // End by priya
    if (item === 'Print Lorry Receipt' && !this.IsFtlMarkedContainerPicked) {
      this.GetLorryReceiptPrint(row.ConsignmentNoteId);
    }
    else if (item === 'Print Lorry Receipt 2') {
      PrintFormatsNewComponent.that.ShipmentModeName = row.ShipmentModeName;
      // this.GetLorryReceiptPrint1(row.ConsignmentNoteId);
      this.GetLorryReceiptPrint2(row.ConsignmentNoteId, row.BookingId);
    }
    else if (item === 'Print Lorry Receipt 3') {
      this.GetLorryReceiptPrint3(row.ConsignmentNoteId, row.BookingId);
    }
    else if (item === 'Print Lorry Receipt 4') {
      // added by BURHAN - 8-July-2026
      this._appService.GetById("Company", "GetTermsAndConditionForPrint", this.CompanyId).subscribe(
        (res) => {
          this.TermsandConditionsLR = res || '';

          PrintFormatsNewComponent.that.PrintFormatsChild.InvoiceType = 'PrintLorryReceipt4';
          PrintFormatsNewComponent.that.PrintFormatsChild.From = 'Destination';
          PrintFormatsNewComponent.that.PrintFormatsChild.ConsignmentNoteId = row.ConsignmentNoteId;
          PrintFormatsNewComponent.that.PrintFormatsChild.CompId = PrintFormatsNewComponent.that.CompanyId;
          // added by BURHAN - 8-July-2026
          PrintFormatsNewComponent.that.PrintFormatsChild.TermsandConditionsLR = this.TermsandConditionsLR;
          // end by BURHAN - 8-July-2026
          $("#PrintInvoice").val("");
          PrintFormatsNewComponent.that.PrintFormatsChild.PrintInvoice();
        },
        (error) => {
          this.TermsandConditionsLR = '';
          PrintFormatsNewComponent.that.PrintFormatsChild.InvoiceType = 'PrintLorryReceipt4';
          PrintFormatsNewComponent.that.PrintFormatsChild.From = 'Destination';
          PrintFormatsNewComponent.that.PrintFormatsChild.ConsignmentNoteId = row.ConsignmentNoteId;
          PrintFormatsNewComponent.that.PrintFormatsChild.CompId = PrintFormatsNewComponent.that.CompanyId;
          PrintFormatsNewComponent.that.PrintFormatsChild.TermsandConditionsLR = '';
          $("#PrintInvoice").val("");
          PrintFormatsNewComponent.that.PrintFormatsChild.PrintInvoice();
        }
      );
      // end by BURHAN - 8-July-2026
    } else if (item === 'Terms And Condition For LR') {
      this.GetTermsAndConditionsForLR();
    }
    else {
      console.log("sabka malik ek!");
    }
  }

  GetTermsAndConditions() {
    this._appService.GetById("Company", "GetTermsAndConditionForPrint", this.CompanyId).subscribe(
      (response) => {
        // const strippedText = response.replace(/<\/?[^>]+(>|$)/g, "");
        this.TermsandConditions = response;
        // console.log("GetTermsAndConditions:", response);
      },
      (error) => {
        console.log("GetTermsAndConditions", error);
      }
    );
  }

  // GetLorryReceiptPrint(ConsignmentNoteId) {
  //   Helpers.setLoading(true);
  //   this._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe(
  //     (response) => {
  //       this.LorryReceiptData = [];
  //       this.LorryReceiptData = response as any;
  //       console.log("ConsignmentsData:", this.LorryReceiptData);
  //       let i = 0;
  //       setTimeout(() => {
  //         this.LorryReceiptData.forEach(
  //           (element) => {

  //             var TotalQty = 0;
  //             var TotalWeight = 0;
  //             var TotalValue = 0;
  //             element.ProductDetail.forEach((element) => {
  //               TotalQty = TotalQty + element.Quantity;
  //               TotalWeight = TotalWeight + element.GrossWeight;
  //               TotalValue = TotalValue + element.Value;
  //             });

  //             element.TotalQty = TotalQty;
  //             element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
  //             element.TotalValue = TotalValue;
  //             i++;
  //           }
  //         );

  //         setTimeout(() => {
  //           var divElements = document.getElementById("Test");
  //           // this.LorryReceiptData = [];
  //           // this.LorryReceiptData.push({ id: 0 });
  //           // this.LorryReceiptData.push({ id: 1 });
  //           // this.LorryReceiptData.push({ id: 2 });
  //          
  //           var $iframe: any = $("<iframe id='frame'>").appendTo("body");
  //           var printDiv =
  //             "<html><head><title> Lorry Receipt </title></head><body>" +
  //             divElements.innerHTML +
  //             "</body></html>";
  //           $iframe.contents().find("body").html(printDiv);
  //           var win = $iframe[0].contentWindow || $iframe[0];
  //           $(win.document).ready(function () {
  //             setTimeout(() => {
  //               win.window.print();
  //               setTimeout(() => {
  //                 $iframe.remove();
  //               }, 500);
  //             }, 100);
  //           });
  //           Helpers.setLoading(false);
  //           $iframe.contents().find("body").html(printDiv);
  //         }, 1000);
  //       }, 200);

  //     },
  //     (err) => {
  //       Helpers.setLoading(false);
  //       this.toastr.error("An error occured  !", "Error");
  //     });
  // }

  // GetLorryReceiptPrint(ConsignmentNoteId) {
  //   Helpers.setLoading(true);
  //   this._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe((response) => {
  //     PrintFormatsNewComponent.that.LorryReceiptData = response;

  //     let i = 0;
  //     setTimeout(() => {
  //       PrintFormatsNewComponent.that.LorryReceiptData.forEach((element) => {
  //         var TotalQty = 0;
  //         var TotalWeight = 0;
  //         var TotalValue = 0;
  //         element.ProductDetail.forEach((element) => {
  //           TotalQty = TotalQty + element.Quantity;
  //           TotalWeight = TotalWeight + element.GrossWeight;
  //           TotalValue = TotalValue + element.Value;
  //         });

  //         element.TotalQty = TotalQty;
  //         element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
  //         element.TotalValue = TotalValue;
  //         i++;
  //       });

  //       // Set the flag to true when the data is loaded
  //       this.dataLoaded = true;

  //       // Only proceed with printing after data is loaded
  //       if (this.dataLoaded) {
  //         setTimeout(() => {
  //           
  //           console.log("ConsignmentsData:", PrintFormatsNewComponent.that.LorryReceiptData);
  //           var divElements = document.getElementById("Test_123");
  //          
  //           var $iframe: any = $("<iframe id='frame'>").appendTo("body");
  //           var printDiv =
  //             "<html><head><title> Lorry Receipt </title></head><body>" +
  //             divElements.innerHTML +
  //             "</body></html>";
  //           $iframe.contents().find("body").html(printDiv);
  //           var win = $iframe[0].contentWindow || $iframe[0];
  //           $(win.document).ready(function () {
  //             setTimeout(() => {
  //               win.window.print();
  //               setTimeout(() => {
  //                 $iframe.remove();
  //               }, 500);
  //             });
  //           });
  //           Helpers.setLoading(false);
  //           $iframe.contents().find("body").html(printDiv);
  //         }, 1000);
  //       }
  //     }, 200);
  //   }, (err) => {
  //     Helpers.setLoading(false);
  //     this.toastr.error("An error occurred!", "Error");
  //   });
  // }


  ngAfterViewInit() {
    PrintFormatsNewComponent.that = this; // Ensure static reference is updated
  }

  ConsignmentsDataLR: any = [];
  GetLorryReceiptPrint(ConsignmentNoteId) {
    Helpers.setLoading(true);

    // added by BURHAN - 8-July-2026
    this._appService.GetById("Company", "GetTermsAndConditionForPrint", this.CompanyId).subscribe(
      (res) => {
        this.TermsandConditionsLR = res || '';
        // end by BURHAN - 8-July-2026

        this._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe(
          (response) => {
            PrintFormatsNewComponent.that.ConsignmentsDataLR = [];
            PrintFormatsNewComponent.that.ConsignmentsDataLR = response;
            this.dataLoaded = true;

            let i = 0;
            this.ConsignmentsDataLR.forEach((element) => {


              if (
                element.Risk == "Owner" ||
                element.Risk == "owner" ||
                element.Risk == "OWNER"
              ) {
                $("#chkOwn_" + i).attr("checked", true);
              } else {
                $("#chkTransporter_" + i).attr("checked", true);
              }

              if (
                element.Freight == "To Pay" ||
                element.Freight == "to pay" ||
                element.Freight == "To pay" ||
                element.Freight == "TO PAY" ||
                element.Freight == "ToPay"
              ) {
                $("#chkToPay_" + i).attr("checked", true);
              } else {
                $("#chkToBill_" + i).attr("checked", true);
              }

              if (
                element.GST == "Consignor" ||
                element.GST == "consignor" ||
                element.GST == "CONSIGNOR"
              ) {
                $("#chkConsignor_" + i).attr("checked", true);
              } else {
                $("#chkGSTTransporter_" + i).attr("checked", true);
              }

              if (element.Insured) {
                $("#chkInsureYes_" + i).attr("checked", true);
              } else {
                $("#chkInsureNo_" + i).attr("checked", true);
              }

              let TotalQty = 0;
              let TotalWeight = 0;
              let TotalValue = 0;
              element.ProductDetail.forEach((product) => {
                TotalQty += product.Quantity;
                TotalWeight += product.GrossWeight;
                TotalValue += product.Value;
              });

              element.TotalQty = TotalQty;
              element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
              element.TotalValue = TotalValue;
              i++;
            });

            setTimeout(() => {
              PrintFormatsNewComponent.that.cdr.detectChanges();
              PrintFormatsNewComponent.that.isPrintReadyLR = true;

              setTimeout(() => {
                let divElements = document.getElementById("ModalConsignmentNoteLR");

                // added by BURHAN - 8-July-2026
                let termsDiv = `
            <div style="page-break-before: always">
              <table style="width: 100%; border-collapse: collapse; font-family: calibri;">
                <tr>
                  <td style="border: 1px solid; padding: 10px;">
                    <h2><i><u>LR TERMS & CONDITION :</u></i></h2>
                    <span style="font-size: 14px">${this.TermsandConditionsLR}</span>
                  </td>
                </tr>
              </table>
            </div>
          `;
                // end by BURHAN - 8-July-2026
                setTimeout(() => {  // Ensure DOM updates before reading innerHTML
                  let $iframe: any = $("<iframe id='frame'>").appendTo("body");
                  // comment by BURHAN - 8-July-2026
                  // let printDiv = `<html><head><title> Lorry Receipt 2</title></head><body>${divElements.innerHTML}</body></html>`;
                  // added by BURHAN - 8-July-2026
                  let printDiv = `<html><head><title> Lorry Receipt 2</title></head><body>${divElements.innerHTML}${termsDiv}</body></html>`;
                  // end by BURHAN - 8-July-2026

                  $iframe.contents().find("body").html(printDiv);
                  let win = $iframe[0].contentWindow || $iframe[0];

                  $(win.document).ready(function () {
                    setTimeout(() => {
                      win.window.print();
                      setTimeout(() => {
                        $iframe.remove();
                        // PrintFormatsNewComponent.that.isPrintReadyLR = false;
                      }, 500);
                    });
                  });

                  Helpers.setLoading(false);
                }, 500); // Extra delay to let the DOM update
              }, 500);
            }, 1500);

          },
          (err) => {
            Helpers.setLoading(false);
            this.toastr.error("An error occurred!", "Error");
          }
        );
      });
  }

  GetLorryReceiptPrint1(ConsignmentNoteId) {
    
    this._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe(
      (response) => {
        this.ConsignmentsData = [];
        this.ConsignmentsData = response;

        let i = 0;
        setTimeout(() => {
          this.ConsignmentsData.forEach((element) => {

            if (
              element.Risk == "Owner" ||
              element.Risk == "owner" ||
              element.Risk == "OWNER"
            ) {
              $("#chkOwn_" + i).attr("checked", true);
            } else {
              $("#chkTransporter_" + i).attr("checked", true);
            }

            if (
              element.Freight == "To Pay" ||
              element.Freight == "to pay" ||
              element.Freight == "To pay" ||
              element.Freight == "TO PAY" ||
              element.Freight == "ToPay"
            ) {
              $("#chkToPay_" + i).attr("checked", true);
            } else {
              $("#chkToBill_" + i).attr("checked", true);
            }

            if (
              element.GST == "Consignor" ||
              element.GST == "consignor" ||
              element.GST == "CONSIGNOR"
            ) {
              $("#chkConsignor_" + i).attr("checked", true);
            } else {
              $("#chkGSTTransporter_" + i).attr("checked", true);
            }

            if (element.Insured) {
              $("#chkInsureYes_" + i).attr("checked", true);
            } else {
              $("#chkInsureNo_" + i).attr("checked", true);
            }

            let TotalQty = 0;
            let TotalWeight = 0;
            let TotalValue = 0;
            element.ProductDetail.forEach((product) => {
              TotalQty += product.Quantity;
              TotalWeight += product.GrossWeight;
              TotalValue += product.Value;
            });

            element.TotalQty = TotalQty;
            element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
            element.TotalValue = TotalValue;
            i++;
          });
        }, 200);
      },
      (err) => {
        console.error(err);
      });
  }

  isPrintReadyLR: boolean = false;
  isPrintReadyLR1: boolean = false;
  isPrintReadyLR2: boolean = false;
  isPrintReadyLR3: boolean = false;
  isPrintReadyLR4: boolean = false;
  GetLorryReceiptPrint2(ConsignmentNoteId, BookingId) {
    Helpers.setLoading(true);

    // added by BURHAN - 8-July-2026
    this._appService.GetById("Company", "GetTermsAndConditionForPrint", this.CompanyId).subscribe(
      (termsResponse) => {
        this.TermsandConditionsLR = termsResponse || '';
        // end by BURHAN - 8-July-2026

        this._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe(
          (response) => {
            PrintFormatsNewComponent.that.ConsignmentsData = [];
            PrintFormatsNewComponent.that.ConsignmentsData = response;
            if (PrintFormatsNewComponent.that.ConsignmentsData.length > 0)
              PrintFormatsNewComponent.that.ConsignmentsData[0].ShipmentModeName = PrintFormatsNewComponent.that.ShipmentModeName;
            let i = 0;
            PrintFormatsNewComponent.that._appService
              .GetByTwoId("Booking", "GetDataForLRPrint", BookingId, PrintFormatsNewComponent.that.CompanyId)
              .subscribe(
                (response) => {
                  Helpers.setLoading(false);
                  if (response.length > 0) {
                    PrintFormatsNewComponent.that.ConsignmentsData[0].DriverName =
                      response[0].DriverName;
                    PrintFormatsNewComponent.that.ConsignmentsData[0].VehicleType =
                      response[0].VehicleType;
                    PrintFormatsNewComponent.that.ConsignmentsData[0].transporterAddress =
                      response[0].transporterAddress;
                    PrintFormatsNewComponent.that.ConsignmentsData[0].LicenseNo =
                      response[0].LicenseNo;
                    PrintFormatsNewComponent.that.ConsignmentsData[0].TransportName =
                      response[0].TransportName;
                    PrintFormatsNewComponent.that.ConsignmentsData[0].eWayBillNo =
                      response[0].eWayBillNo;
                    PrintFormatsNewComponent.that.ConsignmentsData[0].eWayBillExpiryDate =
                      response[0].eWayBillExpiryDate;
                    PrintFormatsNewComponent.that.ConsignmentsData[0].containerNo =
                      response[0].containerNo;
                    PrintFormatsNewComponent.that.ConsignmentsData[0].sealNo =
                      response[0].sealNo;
                    PrintFormatsNewComponent.that.ConsignmentsData[0].DINo =
                      response[0].DINo;
                  }

                  setTimeout(() => {
                    PrintFormatsNewComponent.that.ConsignmentsData.forEach(
                      (element) => {
                        if (
                          element.Risk == "Owner" ||
                          element.Risk == "owner" ||
                          element.Risk == "OWNER"
                        ) {
                          $("#chkOwn_" + i).attr("checked", true);
                        } else {
                          $("#chkTransporter_" + i).attr(
                            "checked",
                            true
                          );
                        }

                        if (
                          element.Freight == "To Pay" ||
                          element.Freight == "to pay" ||
                          element.Freight == "To pay" ||
                          element.Freight == "TO PAY" ||
                          element.Freight == "ToPay"
                        ) {
                          $("#chkToPay_" + i).attr("checked", true);
                        } else {
                          $("#chkToBill_" + i).attr("checked", true);
                        }

                        if (
                          element.GST == "Consignor" ||
                          element.GST == "consignor" ||
                          element.GST == "CONSIGNOR"
                        ) {
                          $("#chkConsignor_" + i).attr("checked", true);
                        } else {
                          $("#chkGSTTransporter_" + i).attr(
                            "checked",
                            true
                          );
                        }

                        if (element.Insured) {
                          $("#chkInsureYes_" + i).attr("checked", true);
                        } else {
                          $("#chkInsureNo_" + i).attr("checked", true);
                        }

                        var TotalQty = 0;
                        var TotalWeight = 0;
                        var TotalValue = 0;
                        element.ProductDetail.forEach((element) => {
                          TotalQty = TotalQty + element.Quantity;
                          TotalWeight =
                            TotalWeight + element.GrossWeight;
                          TotalValue = TotalValue + element.Value;
                        });

                        element.TotalQty = TotalQty;
                        element.TotalWeight = parseFloat(
                          TotalWeight.toFixed(2)
                        );
                        element.TotalValue = TotalValue;
                        i++;
                      }
                    );
                  }, 200);

                  this.LorryReceiptPrint2 = true;

                  setTimeout(() => {
                    PrintFormatsNewComponent.that.cdr.detectChanges();
                    PrintFormatsNewComponent.that.isPrintReadyLR2 = true;
                    setTimeout(() => {
                      let divElements = document.getElementById("ModalLorryReceipt2");

                      // added by BURHAN - 8-July-2026
                      let termsDiv = '';
                      if (this.TermsandConditionsLR && this.TermsandConditionsLR.trim() !== '') {
                        termsDiv = `
                        <div style="page-break-before: always">
                          <table style="width: 100%; border-collapse: collapse; font-family: calibri;">
                            <tr>
                              <td style="border: 1px solid; padding: 10px;">
                                <h2><i><u>LR TERMS & CONDITION :</u></i></h2>
                                <span style="font-size: 14px">${this.TermsandConditionsLR}</span>
                              </td>
                            </tr>
                          </table>
                        </div>
                      `;
                      }
                      // end by BURHAN - 8-July-2026

                      setTimeout(() => {  // Ensure DOM updates before reading innerHTML
                        let $iframe: any = $("<iframe id='frame'>").appendTo("body");
                        // let printDiv = `<html><head><title> Lorry Receipt 2</title></head><body>${divElements.innerHTML}</body></html>`; //comment by BURHAN - 8-July-2026
                        // added by BURHAN - 8-July-2026
                        let printDiv = `<html><head><title> Lorry Receipt 2</title></head><body>${divElements.innerHTML}${termsDiv}</body></html>`;
                        // end by BURHAN - 8-July-2026

                        $iframe.contents().find("body").html(printDiv);
                        let win = $iframe[0].contentWindow || $iframe[0];

                        $(win.document).ready(function () {
                          setTimeout(() => {
                            win.window.print();
                            setTimeout(() => {
                              $iframe.remove();
                              PrintFormatsNewComponent.that.isPrintReadyLR2 = false;
                            }, 500);
                          });
                        });

                        Helpers.setLoading(false);
                      }, 500); // Extra delay to let the DOM update
                    }, 500);
                  }, 1500);

                },
                (err) => {
                  Helpers.setLoading(false);
                  this.toastr.error("An error occurred!", "Error");
                }
              );
          },
          (err) => {
            Helpers.setLoading(false);
            this.toastr.error("An error occured  !", "Error");
          }
        );
      });
  }


  ConsignmentsData3: any = [];
  GetLorryReceiptPrint3(ConsignmentNoteId, BookingId) {
    
    Helpers.setLoading(true);
    // added by BURHAN - 8-July-2026
    this._appService.GetById("Company", "GetTermsAndConditionForPrint", this.CompanyId).subscribe(
      (termsResponse) => {
        this.TermsandConditionsLR = termsResponse || '';
        // end by BURHAN - 8-July-2026

        this._appService.GetById("BookingOrigin", "getConsignmentDetailList", ConsignmentNoteId).subscribe(
          (response) => {
            PrintFormatsNewComponent.that.ConsignmentsData3 = [];
            PrintFormatsNewComponent.that.ConsignmentsData3 = response;
            console.log(response);

            let i = 0;
            PrintFormatsNewComponent.that._appService
              .GetByTwoId("Booking", "GetDataForLRPrint", BookingId, PrintFormatsNewComponent.that.CompanyId)
              .subscribe(
                (response) => {
                  Helpers.setLoading(false);
                  if (response.length > 0) {
                    PrintFormatsNewComponent.that.ConsignmentsData3.forEach(
                      (elementCN1) => {
                        elementCN1.DriverName = response[0].DriverName;
                        elementCN1.VehicleType = response[0].VehicleType;
                        elementCN1.transporterAddress =
                          response[0].transporterAddress;
                        elementCN1.LicenseNo = response[0].LicenseNo;
                        elementCN1.TransportName =
                          response[0].TransportName;
                        elementCN1.eWayBillNo = response[0].eWayBillNo;
                        elementCN1.eWayBillExpiryDate =
                          response[0].eWayBillExpiryDate;
                        elementCN1.containerNo = response[0].containerNo;
                      }
                    );
                  }

                  if (
                    PrintFormatsNewComponent.that.ConsignmentsData3[0]
                      .ReferenceNo != null
                  ) {
                    let printSealNo =
                      PrintFormatsNewComponent.that.ConsignmentsData3[0].ReferenceNo.split(
                        "/"
                      );
                    PrintFormatsNewComponent.that.containerNo =
                      printSealNo[0];
                    this.containerNo = printSealNo[0];
                    if (printSealNo[1]) {
                      PrintFormatsNewComponent.that.sealNo =
                        printSealNo[1].split(":")[1];
                      this.sealNo = printSealNo[1].split(":")[1];
                    }
                  }

                  setTimeout(() => {
                    PrintFormatsNewComponent.that.ConsignmentsData3.forEach(
                      (element) => {
                        if (
                          element.Risk == "Owner" ||
                          element.Risk == "owner" ||
                          element.Risk == "OWNER"
                        ) {
                          $("#chkOwn_" + i).attr("checked", true);
                        } else {
                          $("#chkTransporter_" + i).attr(
                            "checked",
                            true
                          );
                        }

                        if (
                          element.Freight == "To Pay" ||
                          element.Freight == "to pay" ||
                          element.Freight == "To pay" ||
                          element.Freight == "TO PAY" ||
                          element.Freight == "ToPay"
                        ) {
                          $("#chkToPay_" + i).attr("checked", true);
                        } else {
                          $("#chkToBill_" + i).attr("checked", true);
                        }

                        if (
                          element.GST == "Consignor" ||
                          element.GST == "consignor" ||
                          element.GST == "CONSIGNOR"
                        ) {
                          $("#chkConsignor_" + i).attr("checked", true);
                        } else {
                          $("#chkGSTTransporter_" + i).attr(
                            "checked",
                            true
                          );
                        }

                        if (element.Insured) {
                          $("#chkInsureYes_" + i).attr("checked", true);
                        } else {
                          $("#chkInsureNo_" + i).attr("checked", true);
                        }

                        var TotalQty = 0;
                        var TotalWeight = 0;
                        var TotalValue = 0;
                        element.ProductDetail.forEach((element) => {
                          TotalQty = TotalQty + element.Quantity;
                          TotalWeight =
                            TotalWeight + element.GrossWeight;
                          TotalValue = TotalValue + element.Value;
                        });

                        element.TotalQty = TotalQty;
                        element.TotalWeight = parseFloat(
                          TotalWeight.toFixed(2)
                        );
                        element.TotalValue = TotalValue;
                        i++;
                      }
                    );
                  }, 200);


                  setTimeout(() => {
                    PrintFormatsNewComponent.that.cdr.detectChanges();
                    PrintFormatsNewComponent.that.isPrintReadyLR3 = true;

                    setTimeout(() => {
                      let divElements = document.getElementById("ModalLorryReceiptLR3");

                      // added by BURHAN - 8-July-2026
                      let termsDiv = '';
                      if (this.TermsandConditionsLR && this.TermsandConditionsLR.trim() !== '') {
                        termsDiv = `
                        <div style="page-break-before: always">
                          <table style="width: 100%; border-collapse: collapse; font-family: calibri;">
                            <tr>
                              <td style="border: 1px solid; padding: 10px;">
                                <h2><i><u>LR TERMS & CONDITION :</u></i></h2>
                                <span style="font-size: 14px">${this.TermsandConditionsLR}</span>
                              </td>
                            </tr>
                          </table>
                        </div>
                      `;
                      }
                      // end by BURHAN - 8-July-2026

                      setTimeout(() => {  // Ensure DOM updates before reading innerHTML
                        let $iframe: any = $("<iframe id='frame'>").appendTo("body");
                        // let printDiv = `<html><head><title> Lorry Receipt 2</title></head><body>${divElements.innerHTML}</body></html>`;
                        // added by BURHAN - 8-July-2026
                        let printDiv = `<html><head><title> Lorry Receipt 2</title></head><body>${divElements.innerHTML}${termsDiv}</body></html>`;
                        // end by BURHAN - 8-July-2026

                        $iframe.contents().find("body").html(printDiv);
                        let win = $iframe[0].contentWindow || $iframe[0];

                        $(win.document).ready(function () {
                          setTimeout(() => {
                            win.window.print();
                            setTimeout(() => {
                              $iframe.remove();
                              PrintFormatsNewComponent.that.isPrintReadyLR3 = false;
                            }, 500);
                          });
                        });

                        Helpers.setLoading(false);
                      }, 500); // Extra delay to let the DOM update
                    }, 500);
                  }, 1500);
                },
                (err) => {
                  Helpers.setLoading(false);
                  this.toastr.error("An error occurred!", "Error");
                }
              );
          },
          (err) => {
            Helpers.setLoading(false);
            this.toastr.error("An error occured  !", "Error");
          }
        );
      });
  }

  GetLorryReceiptPrint4(ConsignmentNoteId, From) {
    Helpers.setLoading(true);
    PrintFormatsNewComponent.that._appService.GetByTwoId("BookingOrigin", "GetPrintLR4", ConsignmentNoteId, From).subscribe(
      (response) => {
        PrintFormatsNewComponent.that.ConsignmentsData4 = [];
        PrintFormatsNewComponent.that.ConsignmentsData4 = response;
        // PrintFormatsNewComponent.that.ConsignmentsData.push(
        //   ...(response as any)
        // );
        let i = 0;
        setTimeout(() => {
          PrintFormatsNewComponent.that.ConsignmentsData4.forEach((element) => {
            if (
              element.GST == "Consignor" ||
              element.GST == "consignor" ||
              element.GST == "CONSIGNOR"
            ) {
              $(".Consigner_" + i).attr("checked", "true");
            }

            if (
              element.GST == "Consignee" ||
              element.GST == "consigee" ||
              element.GST == "CONSIGEE"
            ) {
              $(".Consignee_" + i).attr("checked", "true");
            }

            if (
              element.GST == "Transporter" ||
              element.GST == "transporter" ||
              element.GST == "TRANSPORTER"
            ) {
              $(".Transporter_" + i).attr("checked", "true");
            }

            var TotalQty = 0;
            var TotalWeight = 0;
            var TotalValue = 0;
            element.ProductDetail.forEach((element) => {
              TotalQty = TotalQty + element.Quantity;
              TotalWeight = TotalWeight + element.GrossWeight;
              TotalValue = TotalValue + element.Value;
            });

            element.TotalQty = TotalQty;
            element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
            element.TotalValue = TotalValue;
            i++;
          });
        }, 200);

        this.cdr.detectChanges();
        setTimeout(() => {
          this.cdr.detectChanges();
          this.isPrintReadyLR4 = true;

          setTimeout(() => {
            let divElements = document.getElementById("PrintLorryReceipt4");
            setTimeout(() => {  // Ensure DOM updates before reading innerHTML
              let $iframe: any = $("<iframe id='frame'>").appendTo("body");
              let printDiv = `<html><head><title> Lorry Receipt 4</title></head><body>${divElements.innerHTML}</body></html>`;

              $iframe.contents().find("body").html(printDiv);
              let win = $iframe[0].contentWindow || $iframe[0];

              console.log('isPrintReadyLR4 =', PrintFormatsNewComponent.that.isPrintReadyLR4);
              console.log('ConsignmentsData4 length =', PrintFormatsNewComponent.that.ConsignmentsData4.length);
              console.log('ConsignmentNote_3 length =', PrintFormatsNewComponent.that.ConsignmentNote_3.length);

              const el = document.getElementById('PrintLorryReceipt4');

              console.log('Element =', el);
              console.log('Children =', el.children.length);
              console.log('InnerHTML =', el.innerHTML);

              $(win.document).ready(function () {
                setTimeout(() => {
                  win.window.print();
                  setTimeout(() => {
                    $iframe.remove();
                    PrintFormatsNewComponent.that.isPrintReadyLR4 = false;
                  }, 500);
                });
              });

              Helpers.setLoading(false);
            }, 500); // Extra delay to let the DOM update
          }, 1000);
        }, 1500);
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("An error occured  !", "Error");
      }
    );
  }

  TotalAmount: any = 0;
  TotalAdvance: any = 0;
  TotalBalance: any = 0;
  isPrintQoute: boolean = false;
  NetTotalAmount: any = 0;
  RoundOfAmount: any = 0;
  TotalCGST: any = 0;
  TotalSGST: any = 0;
  TotalIGST: any = 0;

  NewPrintQuote() {
    Helpers.setLoading(true);
    this._appService.GetByTwoId("OrdersByVehicle", "GetOrderVehicleById", this.OrderId, this.CompanyId).subscribe(
      (response) => {
        this.PrintQuoteData = [];
        if (response) {
          // this.PrintQuoteData = response;
          this.PrintQuoteData.push(response);
          //PrintFormatsComponent.that.PrintQuoteData = response ? [response] : [];
          console.log('PrintQuoteData>>', this.PrintQuoteData);
        }
        console.log('PrintQuoteData', this.PrintQuoteData);
        this.TotalAmount = 0;
        this.TotalAdvance = 0;
        this.TotalBalance = 0;
        let SGST = 0.0;
        let CGST = 0.0;
        let IGST = 0.0;
        let TotalAmt = 0.0;
        let TotalAdvc = 0.0;
        let totalCGST = 0.0;
        let totalSGST = 0.0;
        let totalIGST = 0.0;

        let i = 0;
        this.InvoiceData = [];
        this.QuoteCompanyData = {};
        this.QuoteUserData = {};

        this._appService.GetById("byVehicleIncome", "GetChargeListByIndentId", this.OrderId)
          .subscribe(
            (res) => {
              res.forEach((element) => {
                this.InvoiceData.push(element);
                if (
                  element.Discount == null ||
                  element.Discount == undefined ||
                  element.Discount == ""
                ) {
                  element.Discount = 0;
                }
                element.Amount = element.Quantity * element.Rate;
                element.Amount = element.Amount - element.Discount;
                // this.TotalAmount = this.TotalAmount + element.Amount;
                // this.TotalAdvance = this.TotalAdvance + element.Advance;
                // this.TotalBalance = this.TotalAmount - this.TotalAdvance;
                if (element.ChargedGST != 'NA') {
                  if (element.CGST != null && element.CGST != 0) {
                    CGST = element.Amount * (element.CGST / 100);
                  }
                  if (element.SGST != null && element.SGST != 0) {
                    SGST = element.Amount * (element.SGST / 100);
                  }
                  if (element.IGST != null && element.IGST != 0) {
                    IGST = element.Amount * (element.IGST / 100);
                  }
                }
                else {
                  element.ChargedGST = "NA";
                }

                TotalAmt += element.Amount;
                totalCGST += CGST;
                totalSGST += SGST;
                totalIGST += IGST;
                TotalAdvc += parseFloat(element.Advance);
              });

              this.TotalCGST = totalCGST;
              this.TotalSGST = totalSGST;
              this.TotalIGST = totalIGST;
              this.TotalAmount = TotalAmt;
              this.TotalAdvance = TotalAdvc;
              this.TotalBalance = this.TotalAmount - this.TotalAdvance;
              this.NetTotalAmount = this.TotalAmount + this.TotalCGST + this.TotalSGST + this.TotalIGST;
              this.RoundOfAmount = parseFloat((Math.round(this.NetTotalAmount) - this.NetTotalAmount).toFixed(2));
              this.NetTotalAmount = Math.round(this.NetTotalAmount);

              this._appService
                .GetById("OrdersByVehicle", "GetCompanyForQuote", this.UserId)
                .subscribe(
                  (res) => {
                    // this.QuoteCompanyData = res.Table[0];
                    // this.QuoteUserData = res.Table1[0];
                    this.QuoteCompanyData = res.Table && res.Table.length ? res.Table[0] : {};
                    this.QuoteUserData = res.Table1 && res.Table1.length ? res.Table1[0] : {};

                    this.quoteCompanyEmail = this.QuoteCompanyData.Email || '';
                    this.companyName = this.QuoteCompanyData.Company || '';

                    this.quoteUserName = this.QuoteUserData.UserName || '';
                    this.quoteUserEmail = this.QuoteUserData.Email || '';
                    this.quoteUserPhone = this.QuoteUserData.PhoneNumber || '';


                    setTimeout(() => {
                      this.cdr.detectChanges();
                      this.isPrintQoute = true;

                      setTimeout(() => {
                        let divElements = document.getElementById("Print_Quote_New");

                        setTimeout(() => {  // Ensure DOM updates before reading innerHTML
                          let $iframe: any = $("<iframe id='frame'>").appendTo("body");
                          let printDiv = `<html><head><title> Lorry Receipt 2</title></head><body>${divElements.innerHTML}</body></html>`;
                          $iframe.contents().find("body").html(printDiv);
                          let win = $iframe[0].contentWindow || $iframe[0];

                          $(win.document).ready(function () {
                            setTimeout(() => {
                              win.window.print();
                              setTimeout(() => {
                                $iframe.remove();
                                this.isPrintQoute = false;
                              }, 500);
                            });
                          });

                          Helpers.setLoading(false);
                        }, 500); // Extra delay to let the DOM update
                      }, 500);
                    }, 1500);
                    // setTimeout(() => {
                    // this.cdr.detectChanges();
                    // const divElements = document.getElementById("Print_Quote_New");
                    // // this.divElements = divElements.innerHTML;
                    //   if (divElements) {
                    //     const $iframe: any = $("<iframe id='frame'>").appendTo("body");
                    //     const printDiv = divElements.innerHTML;
                    //     const win = $iframe[0].contentWindow || $iframe[0];
                    //     console.log(divElements.innerHTML);
                    //     $(win.document).ready(() => {
                    //       setTimeout(() => {
                    //         win.window.print();
                    //         setTimeout(() => {
                    //           $iframe.remove();
                    //         }, 500);
                    //       });
                    //     });

                    //     $iframe.contents().find("body").html(printDiv);
                    //   }

                    //   $("#PrintInvoice").val("");
                    //   Helpers.setLoading(false);
                    // }, 1000);

                    Helpers.setLoading(false);
                  },
                  (err) => {
                    Helpers.setLoading(false);
                    this.toastr.error("An error occured  !", "Error");
                  }
                );
            },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("An error occured  !", "Error");
            }
          );
      },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error('Error while fetching print qoute data');
      }
    );
  }

  // Added by priya - 10/01/2026 - print trip profibility - CN - PRIYA-JAN26-008
  PrintTripProfibility() {
    Helpers.setLoading(true);
    // Changed by priya - 15/01/2026 - pass null value for booking id (it should display according to order id only) - CN(PRIYA-JAN26-010)
    this._appService.GetByThreeId("AccountingReport", "acr_GetOrderTripWise_GeneralLedger_Report", this.CompanyId, this.OrderId, null).subscribe((response) => {
      this.OrderData = response.Table;
      if (this.OrderData.length > 0) {
        this.OrderData[0].VehicleType = [];
        if (this.OrderData[0].VehicleTypeJson != null) {
          this.OrderData[0].VehicleType = JSON.parse(this.OrderData[0].VehicleTypeJson);
        }
      }
      this.TripData = response.Table1;
      this.TripIncomeExpenseData = response.Table2;
      for (const td of this.TripData) {
        td.extimated = 0;
        td.actual = 0;
        td.ex_extimated = 0;
        td.ex_actual = 0;
        td.pl_extimated = 0;
        td.pl_extimatedMargin = 0;
        td.pl_actual = 0;
        td.pl_actualMargin = 0;
        for (const ted of this.TripIncomeExpenseData) {
          if (td.tripId == ted.tripId) {
            td.extimated = td.extimated + ted.extimatedAmount;
            td.actual = td.actual + ted.actualAmount;
            td.ex_extimated = td.ex_extimated + ted.ex_extimatedAmount;
            td.ex_actual = td.ex_actual + ted.ex_actualAmount;
            td.pl_extimated = td.pl_extimated + ted.pl_extimated;
            td.pl_actual = td.pl_actual + ted.pl_actual;
          }
        }
        td.pl_extimatedMargin = parseFloat(((td.pl_extimated / (td.extimated == 0 ? 1 : td.extimated)) * 100).toFixed(2)).toFixed(2); //added by fahim (siddharth 25-12-2025)
        td.pl_actualMargin = parseFloat(((td.pl_actual / (td.actual == 0 ? 1 : td.actual)) * 100).toFixed(2)).toFixed(2);   //added by fahim (siddharth 25-12-2025)

        td.extimated = parseFloat(td.extimated).toFixed(2);
        td.actual = parseFloat(td.actual).toFixed(2);
        td.ex_extimated = parseFloat(td.ex_extimated).toFixed(2);
        td.ex_actual = parseFloat(td.ex_actual).toFixed(2);
        td.pl_extimated = parseFloat(td.pl_extimated).toFixed(2);
        td.pl_actual = parseFloat(td.pl_actual).toFixed(2);
      }
      console.log('this.TripData', this.TripData, 'this.TripIncomeExpenseData', this.TripIncomeExpenseData)
      // setTimeout(() => {
      //   this.cdr.detectChanges();
      //   this.IsPrintTripProfibility = true;
      //   setTimeout(() => {
      //     let divElements = document.getElementById("Print_Trip_Profibility");
      //     setTimeout(() => {  // Ensure DOM updates before reading innerHTML
      //       let $iframe: any = $("<iframe id='frame'>").appendTo("body");
      //       let printDiv = `<style type='text/css' media='print'>body {zoom: 90%;} @page { size: landscape;  margin: 0.635cm; }</style><html><head><title> Trip Profibility</title></head><body>${divElements.innerHTML}</body></html>`;

      //       $iframe.contents().find("body").html(printDiv);
      //       let win = $iframe[0].contentWindow || $iframe[0];

      //       $(win.document).ready(function () {
      //         setTimeout(() => {
      //           win.window.print();
      //           setTimeout(() => {
      //             $iframe.remove();
      //             this.IsPrintTripProfibility = true;
      //           }, 500);
      //         });
      //       });

      //       Helpers.setLoading(false);
      //     }, 500); // Extra delay to let the DOM update
      //   }, 500);
      // }, 1500);
      this.cdr.detectChanges();
      setTimeout(() => {
        this.IsPrintTripProfibility = true;
        this.cdr.detectChanges();

        const divElements = document.getElementById("Print_Trip_Profibility");
        if (!divElements) return;

        const iframe = document.createElement("iframe");
        iframe.style.position = "absolute";
        iframe.style.width = "0px";
        iframe.style.height = "0px";
        iframe.style.border = "none";
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(`
          <style type='text/css' media='print'>body {zoom: 90%;} @page { size: landscape;  margin: 0.635cm; }</style>
            <html>
              <head><title>Trip Profibility</title></head>
              <body>${divElements.innerHTML}</body>
            </html>
          `);
        doc.close();

        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        // Cleanup
        setTimeout(() => {
          document.body.removeChild(iframe);
          this.IsPrintTripProfibility = false;
          this.ExpenseVoucherData = [];
        }, 300);
      }, 0);
      Helpers.setLoading(false);
    },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error('Error while fetching print qoute data');
      }
    );
  }

  //added by BURHAN - 13-Feb-2026
  printExpVoucher2() {
    Helpers.setLoading(true);
    this._appService.GetByTwoId("Expense", "td_getExpenseVoucherDataNew", this.ExpenseId, this.UserId).subscribe((response) => {
      var tab1: any = [];
      tab1 = response.Table;
      if (tab1.length > 0) {
        this.ExpenseVoucherData = response.Table;
        this.ExpenseVoucherData[0].chargeList = [];
        var tab2: any = [];
        tab2 = response.Table1;
        if (tab2.length > 0) {
          this.ExpenseVoucherData[0].chargeList = response.Table1;
          this.ExpenseVoucherData[0].TotalChargeAmount = 0;
          this.ExpenseVoucherData[0].chargeList.forEach(element => {
            this.ExpenseVoucherData[0].TotalChargeAmount = this.ExpenseVoucherData[0].TotalChargeAmount + element.ExpenseAmount
          });
        }
      }
      setTimeout(() => {
        //added by BURHAN - 18-Feb-2026
        this.cdr.detectChanges();
        this.IsPrintCashExpenseData = true;

        setTimeout(() => {
          let divElements = document.getElementById("PrintExpenseVoucher2");
          setTimeout(() => {  // Ensure DOM updates before reading innerHTML
            let $iframe: any = $("<iframe id='frame'>").appendTo("body");
            let printDiv = `<style type='text/css' media='print'>body {zoom: 90%;} @page { size: landscape;  margin: 0.635cm; }</style><html><head><title> Expense Voucher </title></head><body>${divElements.innerHTML}</body></html>`;

            $iframe.contents().find("body").html(printDiv);
            let win = $iframe[0].contentWindow || $iframe[0];

            $(win.document).ready(function () {
              setTimeout(() => {
                win.window.print();
                setTimeout(() => {
                  $iframe.remove();
                  this.IsPrintCashExpenseData = true;
                }, 500);
              });
            });

            Helpers.setLoading(false);
          }, 500); // Extra delay to let the DOM update
        }, 500);
        // var divElements = document.getElementById('PrintExpenseVoucher2');
        // var $iframe = $("<iframe>").appendTo("body");
        // var printDiv =
        //   "<html><head><title> Expense Voucher </title></head><body>" +
        //   divElements.innerHTML +
        //   "</body></html>";
        // $iframe.contents().find("body").html(printDiv);
        // var win = $iframe[0].contentWindow || $iframe[0];
        // win.window.print();
        // $iframe.remove();
      }, 1500);
      Helpers.setLoading(false);
      // end by BURHAN - 18-Feb-2026
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      });
  }
  //ended by BURHAN - 13-Feb-2026
  NewPrintQuoteHtmlOnly() {
    Helpers.setLoading(true);
    this._appService.GetByTwoId("OrdersByVehicle", "GetOrderVehicleById", this.OrderId, this.CompanyId).subscribe(
      (response) => {
        this.PrintQuoteData = [];
        if (response) {
          // this.PrintQuoteData = response;
          this.PrintQuoteData.push(response);
          //PrintFormatsComponent.that.PrintQuoteData = response ? [response] : [];
          console.log('PrintQuoteData>>', this.PrintQuoteData);
        }
        console.log('PrintQuoteData', this.PrintQuoteData);
        this.TotalAmount = 0;
        this.TotalAdvance = 0;
        this.TotalBalance = 0;
        let SGST = 0.0;
        let CGST = 0.0;
        let IGST = 0.0;
        let TotalAmt = 0.0;
        let TotalAdvc = 0.0;
        let totalCGST = 0.0;
        let totalSGST = 0.0;
        let totalIGST = 0.0;

        let i = 0;
        this.InvoiceData = [];
        this.QuoteCompanyData = {};
        this.QuoteUserData = {};

        this._appService.GetById("byVehicleIncome", "GetChargeListByIndentId", this.OrderId)
          .subscribe(
            (res) => {
              res.forEach((element) => {
                this.InvoiceData.push(element);
                if (
                  element.Discount == null ||
                  element.Discount == undefined ||
                  element.Discount == ""
                ) {
                  element.Discount = 0;
                }
                element.Amount = element.Quantity * element.Rate;
                element.Amount = element.Amount - element.Discount;
                // this.TotalAmount = this.TotalAmount + element.Amount;
                // this.TotalAdvance = this.TotalAdvance + element.Advance;
                // this.TotalBalance = this.TotalAmount - this.TotalAdvance;
                if (element.ChargedGST != 'NA') {
                  if (element.CGST != null && element.CGST != 0) {
                    CGST = element.Amount * (element.CGST / 100);
                  }
                  if (element.SGST != null && element.SGST != 0) {
                    SGST = element.Amount * (element.SGST / 100);
                  }
                  if (element.IGST != null && element.IGST != 0) {
                    IGST = element.Amount * (element.IGST / 100);
                  }
                }
                else {
                  element.ChargedGST = "NA";
                }

                TotalAmt += element.Amount;
                totalCGST += CGST;
                totalSGST += SGST;
                totalIGST += IGST;
                TotalAdvc += parseFloat(element.Advance);
              });

              this.TotalCGST = totalCGST;
              this.TotalSGST = totalSGST;
              this.TotalIGST = totalIGST;
              this.TotalAmount = TotalAmt;
              this.TotalAdvance = TotalAdvc;
              this.TotalBalance = this.TotalAmount - this.TotalAdvance;
              this.NetTotalAmount = this.TotalAmount + this.TotalCGST + this.TotalSGST + this.TotalIGST;
              this.RoundOfAmount = parseFloat((Math.round(this.NetTotalAmount) - this.NetTotalAmount).toFixed(2));
              this.NetTotalAmount = Math.round(this.NetTotalAmount);

              this._appService
                .GetById("OrdersByVehicle", "GetCompanyForQuote", this.UserId)
                .subscribe(
                  (res) => {
                    // this.QuoteCompanyData = res.Table[0];
                    // this.QuoteUserData = res.Table1[0];
                    this.QuoteCompanyData = res.Table && res.Table.length ? res.Table[0] : {};
                    this.QuoteUserData = res.Table1 && res.Table1.length ? res.Table1[0] : {};

                    this.quoteCompanyEmail = this.QuoteCompanyData.Email || '';
                    this.companyName = this.QuoteCompanyData.Company || '';

                    this.quoteUserName = this.QuoteUserData.UserName || '';
                    this.quoteUserEmail = this.QuoteUserData.Email || '';
                    this.quoteUserPhone = this.QuoteUserData.PhoneNumber || '';


                    setTimeout(() => {
                      this.cdr.detectChanges();
                      this.isPrintQoute = true;

                      setTimeout(() => {
                        let divElements = document.getElementById("Print_Quote_New");

                        setTimeout(() => {
                          let printDiv = `<html><head><title> Lorry Receipt 2</title></head><body>${divElements.innerHTML}</body></html>`;
                          this.divElements = divElements.innerHTML;
                          this.renderComplete.emit();
                          Helpers.setLoading(false);
                        }, 500); // Extra delay to let the DOM update
                      }, 500);
                    }, 1500);
                    Helpers.setLoading(false);
                  },
                  (err) => {
                    Helpers.setLoading(false);
                    this.toastr.error("An error occured  !", "Error");
                  }
                );
            },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("An error occured  !", "Error");
            }
          );
      },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error('Error while fetching print qoute data');
      }
    );
  }

  // Added by priya - 12/02/2026 - cn(PRIYA-FEB26-003)
  printExpenseVoucher() {
    this.ExpenseVoucherData = [];
    this._appService.GetByTwoId("Booking", "td_getTripExpenseVoucherData", this.BookingId, this.UserId).subscribe(
      (response) => {
        var tab1: any = [];
        tab1 = response.Table;
        if (tab1.length > 0) {
          this.ExpenseVoucherData = response.Table;
          this.ExpenseVoucherData[0].chargeList = [];
          var tab2: any = [];
          tab2 = response.Table1;
          if (tab2.length > 0) {
            this.ExpenseVoucherData[0].chargeList = response.Table1;
            this.ExpenseVoucherData[0].TotalChargeAmount = 0;
            this.ExpenseVoucherData[0].chargeList.forEach((element) => {
              this.ExpenseVoucherData[0].TotalChargeAmount =
                this.ExpenseVoucherData[0].TotalChargeAmount + element.Amount;
            });
          }
        }
        console.log('table data', tab1, tab2, this.ExpenseVoucherData)
        this.cdr.detectChanges();
        setTimeout(() => {
          this.IsPrintExpenseVoucher = true;
          this.cdr.detectChanges();

          const divElements = document.getElementById("PrintExpenseVoucher");
          if (!divElements) return;

          const iframe = document.createElement("iframe");
          iframe.style.position = "absolute";
          iframe.style.width = "0px";
          iframe.style.height = "0px";
          iframe.style.border = "none";
          document.body.appendChild(iframe);

          const doc = iframe.contentWindow.document;
          doc.open();
          doc.write(`
            <html>
              <head><title>Expense Voucher</title></head>
              <body>${divElements.innerHTML}</body>
            </html>
          `);
          doc.close();

          iframe.contentWindow.focus();
          iframe.contentWindow.print();

          // Cleanup
          setTimeout(() => {
            document.body.removeChild(iframe);
            this.IsPrintExpenseVoucher = false;
            this.ExpenseVoucherData = [];
          }, 300);
        }, 0);
        // setTimeout(() => {
        //   this.cdr.detectChanges();
        //   this.IsPrintExpenseVoucher = true;
        //   setTimeout(() => {
        //     let divElements = document.getElementById("PrintExpenseVoucher");
        //     setTimeout(() => {  // Ensure DOM updates before reading innerHTML
        //       let $iframe: any = $("<iframe id='frame'>").appendTo("body");
        //       var printDiv =
        //         "<html><head><title> Expense Voucher </title></head><body>" +
        //         divElements.innerHTML +
        //         "</body></html>";
        //       $iframe.contents().find("body").html(printDiv);
        //       let win = $iframe[0].contentWindow || $iframe[0];

        //       $(win.document).ready(function () {
        //         setTimeout(() => {
        //           win.window.print();
        //           setTimeout(() => {
        //             $iframe.remove();
        //             this.IsPrintExpenseVoucher = false;
        //             this.ExpenseVoucherData = [];
        //           }, 500);
        //         });
        //       });

        //       Helpers.setLoading(false);
        //     }, 500); // Extra delay to let the DOM update
        //   }, 500);
        // }, 1500);
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  //added by Burhan - 23-Feb-2026
  PrintPaymentReceiptVoucher() {
    this._appService.GetById("Sales", "NewGetPaymentReceiptById", this.InvoiceId).subscribe((response) => {
      this.OrderDetails = response.Table;//removed [0]
      this.OrderListDetails = response.Table1;

      //added by burhan - 24-Feb-2026 - Calculation for Total Amounts
      //added by burhan -24-Feb-2026
      this.CalculatedAmounts.TotalAdjustedAmount = 0;
      this.CalculatedAmounts.TotalTDSDeduction = 0;
      this.CalculatedAmounts.TotalBalanceDue = 0;
      //end by burhan
      this.OrderListDetails.forEach((element) => {

        const paid = element.PaidAmount || 0.00;
        const tds = element.Deduction || 0.00;

        this.CalculatedAmounts.TotalAdjustedAmount += paid;
        this.CalculatedAmounts.TotalTDSDeduction += tds;

      });
      console.log("TotalAdjustedAmount", this.CalculatedAmounts.TotalAdjustedAmount,
        'TotalTDSDeduction', this.CalculatedAmounts.TotalTDSDeduction);

      if (this.OrderDetails && this.OrderDetails.length > 0) {

        const receipt = this.OrderDetails[0];

        const amount = receipt.Amount || 0;
        const netTotal = receipt.NetTotal || 0;
        const refund = receipt.RefundAmount || 0;
        const roundOff = receipt.RoundOff || 0;

        this.CalculatedAmounts.TotalBalanceDue =
          amount - netTotal - refund - roundOff;

        console.log('TotalBalanceDue', this.CalculatedAmounts.TotalBalanceDue);
      }
      //end by burhan

      console.log(response);
      //this.CalculateNetAmounts();
      if (!this.OrderDetails.length || !this.OrderListDetails.length) {
        this.toastr.warning('warning', 'No Data found For Print');
        Helpers.setLoading(false);
        return;
      }
      console.log('Order Details Data :', response);
      setTimeout(() => {
        this.cdr.detectChanges();
        this.IsPrintReceiptVoucher = true;
        setTimeout(() => {
          let divElements = document.getElementById("PrintReceiptVoucher");
          setTimeout(() => {  // Ensure DOM updates before reading innerHTML
            let $iframe: any = $("<iframe id='frame'>").appendTo("body");
            var printDiv =
              "<html><head><title> Print Receipt Voucher </title></head>" +
              divElements.innerHTML +
              "</html>";
            $iframe.contents().find("body").html(printDiv);
            let win = $iframe[0].contentWindow || $iframe[0];

            $(win.document).ready(function () {
              setTimeout(() => {
                win.window.print();
                setTimeout(() => {
                  $iframe.remove();
                  this.IsPrintReceiptVoucher = false;
                  this.ExpenseVoucherData = [];
                  Helpers.setLoading(false);
                }, 500);
              });
            });

            Helpers.setLoading(false);
          }, 500); // Extra delay to let the DOM update
        }, 500);
      }, 1500);
    },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error("Error While Getting Receipt Voucher Data", error);
      });
  }

  PrintPaymentMadeVoucher() {
    this._appService.GetById("BillPayment", "GetPaymentMadeById", this.InvoiceId).subscribe((response) => {
      this.Payments = [response];
      //this.GetNetAdvanceBalanceAmount()
      if (this.Payments[0].IsAdvancePayment == false) {
        const formattedResponse = response.PaymentDetails.map((item: any) => ({
          ...item,
          Date: item.Date ? this.datepipe.transform(new Date(item.Date), 'dd-MMM-yyyy') : null,
        }));

        this.Payments[0].PaymentDetails = formattedResponse;
      }

      //add by burhan - 26-Feb-2026
      const receipt = this.Payments[0];
      let calculatedNetTotal = 0;
      let calculatedTotalTDS = 0;

      (receipt.PaymentDetails || []).forEach((item: any) => {
        const paid = Number(item.PaidAmount || item.Payment || 0);
        const tds = Number(item.TDSAmount || 0);
        calculatedNetTotal += paid;
        calculatedTotalTDS += tds;
      });

      let calculatedRoundOff = 0;
      if (!receipt.IsAdvancePayment) {
        calculatedRoundOff = calculatedNetTotal - Number(receipt.Amount || 0);
      }

      const calculatedAmountBalance = Number(receipt.Amount || 0) - calculatedNetTotal;
      const calculatedTDSBalance = Number(receipt.TDSAmount) - calculatedTotalTDS;

      receipt.calculatedNetTotal = calculatedNetTotal;
      receipt.calculatedTotalTDS = calculatedTotalTDS;
      receipt.calculatedRoundOff = calculatedRoundOff;
      receipt.calculatedAmountBalance = calculatedAmountBalance;
      receipt.calculatedTDSBalance = calculatedTDSBalance;
      //end by burhan - 26-Feb-2026

      setTimeout(() => {
        this.cdr.detectChanges();
        this.IsPrintPaymentVoucher = true;
        setTimeout(() => {
          let divElements = document.getElementById("PrintPaymentVoucher");
          if (!divElements) {
            Helpers.setLoading(false);
            return;
          }
          setTimeout(() => {  // Ensure DOM updates before reading innerHTML
            let $iframe: any = $("<iframe id='frame'>").appendTo("body");
            var printDiv =
              "<html><head><title> Print Payment Voucher </title></head>" +
              divElements.innerHTML +
              "</html>";
            $iframe.contents().find("body").html(printDiv);
            let win = $iframe[0].contentWindow || $iframe[0];

            $(win.document).ready(function () {
              setTimeout(() => {
                win.window.print();
                setTimeout(() => {
                  $iframe.remove();
                  this.IsPrintPaymentVoucher = false;
                  this.ExpenseVoucherData = [];

                  Helpers.setLoading(false);
                }, 500);
              });
            });

            Helpers.setLoading(false);
          }, 500); // Extra delay to let the DOM update
        }, 500);
      }, 1500);
      console.log('res', response)
    },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error("Error While Getting Invoice Date", error);
      });
  }

  // Added by priya - 24/02/2026 - cn(PRIYA-FEB26-005)
  GetUserCompany(): Promise<void> {
    return new Promise((resolve, reject) => {
      const apiUrl = environment.apiUrl + "api/Company/GetUserCompanyDataByInvoice?id=" + this.CompanyId + "&param1=CompanyId";
      this.http.get(apiUrl).subscribe(
        (response: any) => {

          this.TenantUsers = response.data;

          this.TenantUsers.forEach((element) => {
            this.CompanyId = element.Id;
            this.SelectedComapnyName = element.SelectedComapnyName;
            this.SelectedCompanyAdd = element.SelectedCompanyAdd;
            this.SelectedCompanyLogoImg =
              environment.apiUrl + element.CompanyLogoPath;
            this.ParentCompanyName = element.ParentCompanyName;
          });

          resolve(); // ✅ tell await we are done
        },
        (error) => {
          console.error("Error occurred", error);
          reject(error);
        }
      );
    });
  }

  // Added by priya - 24/02/2026 - cn(PRIYA-FEB26-005)
  GetPrintBillData() {
    this.PrintBillData = [];
    this._appService.GetByTwoId("Bills", "bill_GetPrintBillData", this.BillId, this.ReportType).subscribe(
      (response) => {
        if (response.length > 0) {
          this.PrintBillData = response;
          this.PrintBillData[0].BillDetailDataArray = [];
          let resObj: any = [];
          if (this.PrintBillData[0].BillDetailData != null && this.PrintBillData[0].BillDetailData != "") {
            resObj = JSON.parse(this.PrintBillData[0].BillDetailData);
            this.PrintBillData[0].BillDetailDataArray = resObj;
            if (this.PrintBillData[0].isDebit) {
              this.PrintBillData[0].BillDetailDataArray.forEach((item) => {
                item.Rate = item.Rate < 0 ? -item.Rate : item.Rate;
                item.Discount = item.Discount < 0 ? -item.Discount : item.Discount;
                item.Amount = item.Amount < 0 ? -item.Amount : item.Amount;
              });
            }
          }
        }
        else {
          Helpers.setLoading(false);
          this.toastr.warning("No Data Found For Print");
          return;
        }
        this.cdr.detectChanges();
        setTimeout(() => {
          this.IsPrintDetailBill = true;
          this.cdr.detectChanges();

          const divElements = document.getElementById("PrintDetailBills");
          if (!divElements) {
            Helpers.setLoading(true);
            return;
          }

          const iframe = document.createElement("iframe");
          iframe.style.position = "absolute";
          iframe.style.width = "0px";
          iframe.style.height = "0px";
          iframe.style.border = "none";
          document.body.appendChild(iframe);

          const doc = iframe.contentWindow.document;
          doc.open();
          doc.write(`
            <html>
              <head><title>Details</title></head>
              <body>${divElements.innerHTML}</body>
            </html>
          `);
          doc.close();

          iframe.contentWindow.focus();
          iframe.contentWindow.print();

          setTimeout(() => {
            document.body.removeChild(iframe);
            this.IsPrintDetailBill = false;
            this.PrintBillData = [];
            Helpers.setLoading(false);
          }, 300);
        }, 0);
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
    Helpers.setLoading(false);
  }

  NewPrintPaymentVoucher() {
    console.log(this.OrderId);
    Helpers.setLoading(true);
    this._appService.GetById('JournalEntry', 'PrintJournalEntry', this.OrderId).subscribe(
      (response) => {

        this.PrintJournalEntryData = [];
        this.PrintJournalEntryData = response;
        this.PrintVoucherNo = response[0].VoucherNo;
        this.PrintPostingDate = response[0].PostingDate;
        this.PrintAddress = response[0].Address;
        this.totalDebit = 0;
        this.totalCredit = 0;
        this.PrintJEType = response[0].Type;
        this.PrintDescription = response[0].Description;
        this.PrintReferenceNo = response[0].ReferenceNo;
        this.PrintReferenceDate = response[0].ReferenceDate;
        for (let i = 0; i < response.length; i++) {
          this.totalDebit += response[i].Debit;
          this.totalCredit += response[i].Credit;
        }

        // Helpers.setLoading(false);

        setTimeout(() => {
          this.cdr.detectChanges();
          this.isPrintJournalEntry = true;
          setTimeout(() => {
            var divElements = document.getElementById("NewJournalEntry_Print");
            var $iframe = $("<iframe id='frame'>").appendTo("body");
            var printDiv = divElements.innerHTML;
            console.log(divElements.innerHTML);
            var win = $iframe[0].contentWindow || $iframe[0];
            $(win.document).ready(() => {
              setTimeout(() => {
                win.window.print();
                setTimeout(() => {
                  $iframe.remove();
                  this.isPrintJournalEntry = false;
                }, 500);
              });
            });
            $iframe.contents().find("body").html(printDiv);

            Helpers.setLoading(false);
          }, 1000);
        }, 1500);

      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "Error")
        Helpers.setLoading(false);
      }
    )
  }


  isPrintInvoiceCustom: boolean = false;
  obvPrintData: any = [];
  obv_Print_PremvatiEInvoice() {
    Helpers.setLoading(true);
    let obj: any = {};
    obj.userId = this.UserId;
    obj.companyId = this.CompanyId;
    obj.orderId = this.OrderId;
    obj.consignmentDetailId = this.ConsignmentDetailId;
    obj.InvoiceNo = this.InvoiceNo;
    obj.BookingId = this.BookingId;

    this._appService.Post("so_GoodsOutward", "GetPremvatiInvoiceDataForPrint", obj).subscribe(
      (response) => {
        this.obvPrintData = [];
        if (response.Table.length !== 0) {
          this.obvPrintData = response.Table;
          for (const item of this.obvPrintData) {
            item.InvoiceDetails = [];
            if (item.invoiceDataList != null) {
              item.InvoiceDetails = JSON.parse(item.invoiceDataList);
            }
          }

          const formatNumberWithCommas = (value: number | string): string => {
            return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
          };

          for (const item of this.obvPrintData) {
            item.GrossTotalAmount = 0;
            item.DiscountAmount = 0;
            item.TaxableAmount = 0;
            item.totalSgstAmount = 0;
            item.totalCgstAmount = 0;
            item.totalIgstAmount = 0;
            item.totalCessAmount = 0;
            item.FinalAmount = 0;
            item.FinalAmountCurrencyWise = 0;
            item.totalCTNQty = 0;
            item.totalInvoiceAmount = 0;
            item.totalproductNetWeight = 0;
            item.totalproductGrossWeight = 0;
            // item.roundOff = 0;
            for (const itemPrd of item.InvoiceDetails) {
              const shippingCost = Number(itemPrd.TotalShippingCost) || 0;
              const unitPrice = Number(itemPrd.UnitPrice) || 0;
              const Qty = Number(itemPrd.NewQty) || 0;
              itemPrd.CustomRate = (shippingCost + unitPrice).toFixed(2);
              itemPrd.CustomAmount = (itemPrd.CustomRate * Qty).toFixed(2);
              item.GrossTotalAmount += Number(itemPrd.netAmount) || 0;
              item.DiscountAmount += Number(itemPrd.Discount) || 0;
              item.TaxableAmount += Number(itemPrd.InvoiceAmount) || 0;
              item.totalSgstAmount += Number(itemPrd.sgstAmount) || 0;
              item.totalCgstAmount += Number(itemPrd.cgstAmount) || 0;
              item.totalIgstAmount += Number(itemPrd.igstAmount) || 0;
              item.totalCessAmount += Number(itemPrd.cessAmount) || 0;
              item.FinalAmount += Number(itemPrd.Qty) || 0;
              item.totalCTNQty += Number(itemPrd.QuantityUOM) || 0;
              item.totalInvoiceAmount += Number(itemPrd.CustomAmount) || 0;
              item.totalproductNetWeight += Number(itemPrd.productNetWeight) || 0;
              itemPrd.productGrossWeight = (Number(itemPrd.Qty) * 0.5) + Number(itemPrd.productNetWeight);
              // item.roundOff = parseFloat(parseFloat(item.roundOff) + itemPrd.roundOff).toFixed(2); 
            }

            item.totalproductGrossWeight = (item.totalCTNQty * 0.5) + item.totalproductNetWeight

            item.GrossTotalAmount = item.GrossTotalAmount.toFixed(2);
            item.DiscountAmount = item.DiscountAmount.toFixed(2);
            item.TaxableAmount = item.TaxableAmount.toFixed(2);
            item.totalSgstAmount = item.totalSgstAmount.toFixed(2);
            item.totalCgstAmount = item.totalCgstAmount.toFixed(2);
            item.totalIgstAmount = item.totalIgstAmount.toFixed(2);
            item.totalCessAmount = item.totalCessAmount.toFixed(2);
            item.FinalAmount = item.FinalAmount.toFixed(2);
            item.totalCTNQty = item.totalCTNQty.toFixed(2);
            item.totalInvoiceAmount = item.totalInvoiceAmount.toFixed(2);
            item.totalproductNetWeight = item.totalproductNetWeight.toFixed(2);
            item.FinalAmount = Math.round(item.FinalAmount);
            item.FinalAmountCurrencyWise = (parseFloat(item.FinalAmount) * parseFloat(item.ExchangeRate)).toFixed(2);

            item.GrossTotalAmount = formatNumberWithCommas(item.GrossTotalAmount);
            item.DiscountAmount = formatNumberWithCommas(item.DiscountAmount);
            item.TaxableAmount = formatNumberWithCommas(item.TaxableAmount);
            item.totalSgstAmount = formatNumberWithCommas(item.totalSgstAmount);
            item.totalCgstAmount = formatNumberWithCommas(item.totalCgstAmount);
            item.totalIgstAmount = formatNumberWithCommas(item.totalIgstAmount);
            item.totalCessAmount = formatNumberWithCommas(item.totalCessAmount);
            item.FinalAmount = formatNumberWithCommas(item.FinalAmount);
            item.FinalAmountCurrencyWise = formatNumberWithCommas(item.FinalAmountCurrencyWise);
            item.totalInvoiceAmount = formatNumberWithCommas(item.totalInvoiceAmount);
            item.totalproductNetWeight = formatNumberWithCommas(item.totalproductNetWeight);

            item.totalInvoiceAmountWords = this.amountInWords(item.totalInvoiceAmount, item.CurrencyName);
          }
        }

        setTimeout(() => {
          this.cdr.detectChanges();
          this.isPrintInvoiceCustom = true;

          setTimeout(() => {
            var divElements = document.getElementById("Prem_PrintInvoiceCustom");
            var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
            var printDiv =
              "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }.footer {position: fixed;bottom: 0;left: 0;width: 100%;text-align: left;font-weight: bold;font-size: small;}</style><html ><head><title></title></head><body>" +
              divElements.innerHTML +
              "</body></html>";
            var win = $iframe[0].contentWindow || $iframe[0];
            console.log(divElements.innerHTML);
            $(win.document).ready(function () {
              setTimeout(() => {
                win.window.print();
                setTimeout(() => {
                  $iframe.remove();
                  this.isPrintInvoiceCustom = false;
                }, 1000);
              });
            });
            $iframe.contents().find("body").html(printDiv);
            Helpers.setLoading(false);
          }, 300);

        }, 1500);
        Helpers.setLoading(false);
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  private amountInWords(amount: number | string, currency: string): string {
    const numericAmount = Number(amount.toString().replace(/,/g, ''));
    if (isNaN(numericAmount)) return '';

    const parts = numericAmount.toFixed(2).split('.');
    const whole: number = parseInt(parts[0], 10);
    const fraction: number = parseInt(parts[1], 10);

    const currencyMap: Record<string, [string, string]> = {
      'AUD': ['DOLLARS', 'CENTS'],
      'USD': ['DOLLARS', 'CENTS'],
      'EUR': ['EUROS', 'CENTS'],
      'AED': ['DIRHAMS', 'FILS'],
      'INR': ['RUPEES', 'PAISE'],
      'SAR': ['RIYALS', 'HALALAS']
    };

    const [major, minor] = currencyMap[currency] || ['UNITS', 'SUBUNITS'];

    let words = `${this.numberToWords(whole)} ${major}`;
    if (fraction > 0) {
      words += ` AND ${this.numberToWords(fraction)} ${minor}`;
    }

    return `${currency} - ${words} ONLY`;
  }

  private numberToWords(num: number): string {
    const a = [
      '', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN',
      'ELEVEN', 'TWELVE', 'THIRTEEN', 'FOURTEEN', 'FIFTEEN', 'SIXTEEN',
      'SEVENTEEN', 'EIGHTEEN', 'NINETEEN'
    ];
    const b = ['', '', 'TWENTY', 'THIRTY', 'FORTY', 'FIFTY', 'SIXTY', 'SEVENTY', 'EIGHTY', 'NINETY'];

    if (num < 20) return a[num];
    if (num < 100) return b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '');
    if (num < 1000) return a[Math.floor(num / 100)] + ' HUNDRED' + (num % 100 ? ' ' + this.numberToWords(num % 100) : '');
    if (num < 1000000) return this.numberToWords(Math.floor(num / 1000)) + ' THOUSAND' + (num % 1000 ? ' ' + this.numberToWords(num % 1000) : '');
    if (num < 1000000000) return this.numberToWords(Math.floor(num / 1000000)) + ' MILLION' + (num % 1000000 ? ' ' + this.numberToWords(num % 1000000) : '');
    return '';
  }

  isPrintInvoiceClientCopy: boolean = false;

  obv_Print_PremvatiEInvoiceClientCopy() {
    Helpers.setLoading(true);
    let obj: any = {};
    obj.userId = this.UserId;
    obj.companyId = this.CompanyId;
    obj.orderId = this.OrderId;
    obj.consignmentDetailId = this.ConsignmentDetailId;
    obj.InvoiceNo = this.InvoiceNo;
    obj.BookingId = this.BookingId;

    this._appService.Post("so_GoodsOutward", "GetPremvatiPackingListPrint", obj).subscribe((response) => {
      this.obvPrintData = [];
      if (response.Table.length !== 0) {
        this.obvPrintData = response.Table;
        for (const item of this.obvPrintData) {
          item.InvoiceDetails = [];
          if (item.invoiceDataList != null) {
            item.InvoiceDetails = JSON.parse(item.invoiceDataList);
          }

          // item.ComponentRate = [];
          // if (item.invoiceTaxDetailDataList != null) {
          //     item.ComponentRate = JSON.parse(item.invoiceTaxDetailDataList);
          // }

          // item.BankAccountDetails = [];
          // if (item.accountDetailDataList != null) {
          //     item.BankAccountDetails = JSON.parse(item.accountDetailDataList);
          // }
        }

        const formatNumberWithCommas = (value: number | string): string => {
          return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
        };

        for (const item of this.obvPrintData) {
          item.GrossTotalAmount = 0;
          item.DiscountAmount = 0;
          item.TaxableAmount = 0;
          item.totalSgstAmount = 0;
          item.totalCgstAmount = 0;
          item.totalIgstAmount = 0;
          item.totalCessAmount = 0;
          item.FinalAmount = 0;
          item.FinalAmountCurrencyWise = 0;
          item.totalCTNQty = 0;
          item.totalInvoiceAmount = 0;
          item.totalproductNetWeight = 0;
          item.totalproductGrossWeight = 0;
          // item.roundOff = 0;
          for (const itemPrd of item.InvoiceDetails) {
            const Qty = Number(itemPrd.NewQty) || 0;
            const UnitPrice = Number(itemPrd.UnitPrice) || 0;
            itemPrd.InvoiceAmount = (UnitPrice * Qty).toFixed(2);
            item.GrossTotalAmount += Number(itemPrd.netAmount) || 0;
            item.DiscountAmount += Number(itemPrd.Discount) || 0;
            item.TaxableAmount += Number(itemPrd.InvoiceAmount) || 0;
            item.totalSgstAmount += Number(itemPrd.sgstAmount) || 0;
            item.totalCgstAmount += Number(itemPrd.cgstAmount) || 0;
            item.totalIgstAmount += Number(itemPrd.igstAmount) || 0;
            item.totalCessAmount += Number(itemPrd.cessAmount) || 0;
            item.FinalAmount += Number(itemPrd.Qty) || 0;
            item.totalCTNQty += Number(itemPrd.QuantityUOM) || 0;
            item.totalInvoiceAmount += Number(itemPrd.InvoiceAmount) || 0;
            item.totalproductNetWeight += Number(itemPrd.productNetWeight) || 0;
            item.totalproductGrossWeight += Number(itemPrd.productGrossWeight) || 0;
            // itemPrd.productGrossWeight = (Number(itemPrd.Qty) * 0.5) + Number(itemPrd.productNetWeight);
            // item.roundOff = parseFloat(parseFloat(item.roundOff) + itemPrd.roundOff).toFixed(2); 
          }

          // item.totalproductGrossWeight=(item.totalCTNQty * 0.5) + item.totalproductNetWeight

          item.GrossTotalAmount = item.GrossTotalAmount.toFixed(2);
          item.DiscountAmount = item.DiscountAmount.toFixed(2);
          item.TaxableAmount = item.TaxableAmount.toFixed(2);
          item.totalSgstAmount = item.totalSgstAmount.toFixed(2);
          item.totalCgstAmount = item.totalCgstAmount.toFixed(2);
          item.totalIgstAmount = item.totalIgstAmount.toFixed(2);
          item.totalCessAmount = item.totalCessAmount.toFixed(2);
          item.FinalAmount = item.FinalAmount.toFixed(2);
          item.totalCTNQty = item.totalCTNQty.toFixed(2);
          item.totalInvoiceAmount = item.totalInvoiceAmount.toFixed(2);
          item.totalproductNetWeight = item.totalproductNetWeight.toFixed(3);
          item.totalproductGrossWeight = item.totalproductGrossWeight.toFixed(3);
          item.FinalAmount = Math.round(item.FinalAmount);
          item.FinalAmountCurrencyWise = (parseFloat(item.FinalAmount) * parseFloat(item.ExchangeRate)).toFixed(2);


          item.GrossTotalAmount = formatNumberWithCommas(item.GrossTotalAmount);
          item.DiscountAmount = formatNumberWithCommas(item.DiscountAmount);
          item.TaxableAmount = formatNumberWithCommas(item.TaxableAmount);
          item.totalSgstAmount = formatNumberWithCommas(item.totalSgstAmount);
          item.totalCgstAmount = formatNumberWithCommas(item.totalCgstAmount);
          item.totalIgstAmount = formatNumberWithCommas(item.totalIgstAmount);
          item.totalCessAmount = formatNumberWithCommas(item.totalCessAmount);
          item.FinalAmount = formatNumberWithCommas(item.FinalAmount);
          item.FinalAmountCurrencyWise = formatNumberWithCommas(item.FinalAmountCurrencyWise);
          item.totalInvoiceAmount = formatNumberWithCommas(item.totalInvoiceAmount);
          // item.totalproductNetWeight = formatNumberWithCommas(item.totalproductNetWeight);

          item.totalInvoiceAmountWords = this.amountInWords(item.totalInvoiceAmount, item.CurrencyName);

        }
      }

      setTimeout(() => {
        this.cdr.detectChanges();
        this.isPrintInvoiceClientCopy = true;
        setTimeout(() => {
          var divElements = document.getElementById("Prem_PrintClientCopyInvoice");
          var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
          var printDiv =
            "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }.footer {position: fixed;bottom: 0;left: 0;width: 100%;text-align: left;font-weight: bold;font-size: small;}</style><html ><head><title></title></head><body>" +
            divElements.innerHTML +
            "</body></html>";
          var win = $iframe[0].contentWindow || $iframe[0];
          console.log(divElements.innerHTML);
          $(win.document).ready(function () {
            setTimeout(() => {
              win.window.print();
              setTimeout(() => {
                $iframe.remove();
                this.isPrintInvoiceClientCopy = true;
              }, 1000);
            });
          });
          $iframe.contents().find("body").html(printDiv);
          Helpers.setLoading(false);
        }, 300);
      }, 1500);
      Helpers.setLoading(false);
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  isTermsandConditionsLR: boolean = false;
  // GetTermsAndConditionsForLR() {
  //   Helpers.setLoading(true);
  //   this._appService.GetById("Company", "GetTermsAndConditionForPrint", this.CompanyId).subscribe(
  //     (response) => {
  //       this.TermsandConditionsLR = response;

  //         setTimeout(() => {
  //           PrintFormatsNewComponent.that.cdr.detectChanges();
  //           PrintFormatsNewComponent.that.isTermsandConditionsLR = true;

  //           setTimeout(() => {
  //             let divElements = document.getElementById("Print_TermsandConditionsLR");

  //             setTimeout(() => {  // Ensure DOM updates before reading innerHTML
  //               let $iframe: any = $("<iframe id='frame'>").appendTo("body");
  //               let printDiv = `<html><head><title> Lorry Receipt 2</title></head><body>${divElements.innerHTML}</body></html>`;

  //               $iframe.contents().find("body").html(printDiv);
  //               let win = $iframe[0].contentWindow || $iframe[0];

  //               $(win.document).ready(function () {
  //                 setTimeout(() => {
  //                   win.window.print();
  //                   setTimeout(() => {
  //                     $iframe.remove();
  //                   }, 500);
  //                 });
  //               });

  //               Helpers.setLoading(false);
  //             }, 500); // Extra delay to let the DOM update
  //           }, 500);
  //         }, 1500);

  //         // setTimeout(() => {
  //         //   this.cdr.detectChanges();
  //         //   this.isTermsandConditionsLR = true;
  //         //   let divElements = document.getElementById("Print_TermsandConditionsLR");

  //         //   setTimeout(() => {  // Ensure DOM updates before reading innerHTML
  //         //     let $iframe: any = $("<iframe id='frame'>").appendTo("body");
  //         //     let printDiv = `<html><head><title> Lorry Receipt Terms and Conditions</title></head><body>${divElements.innerHTML}</body></html>`;

  //         //     $iframe.contents().find("body").html(printDiv);
  //         //     let win = $iframe[0].contentWindow || $iframe[0];

  //         //     $(win.document).ready(function () {
  //         //       setTimeout(() => {
  //         //         win.window.print();
  //         //         setTimeout(() => {
  //         //           $iframe.remove();
  //         //           PrintFormatsNewComponent.that.isTermsandConditionsLR = false;
  //         //         }, 500);
  //         //       });
  //         //     });

  //         //     Helpers.setLoading(false);
  //         //   }, 500); // Extra delay to let the DOM update
  //         // }, 500);
  //     },
  //     (error) => {
  //       Helpers.setLoading(false);
  //       console.log("GetTermsAndConditions", error);
  //     }
  //   );
  // }


  GetTermsAndConditionsForLR() {
    Helpers.setLoading(true);
    this._appService.GetById("Company", "GetTermsAndConditionForPrint", this.CompanyId).subscribe(
      (response) => {
        this.TermsandConditionsLR = response || '';
        this.isTermsandConditionsLR = true;

        this.cdr.detectChanges();

        setTimeout(() => {
          let divElements = document.getElementById("Print_TermsandConditionsLR");

          if (!divElements) {
            Helpers.setLoading(false);
            return;
          }

          let $iframe: any = $("<iframe id='frame'>").appendTo("body");

          let printDiv = `
            <html>
              <head>
                <title>Lorry Receipt Terms and Conditions</title>
              </head>
              <body>
                ${divElements.innerHTML}
              </body>
            </html>`;

          $iframe.contents().find("body").html(printDiv);

          let win = $iframe[0].contentWindow || $iframe[0];

          setTimeout(() => {
            win.focus();
            win.print();

            setTimeout(() => {
              $iframe.remove();
              this.isTermsandConditionsLR = false;
              Helpers.setLoading(false);
            }, 500);
          }, 500);

        }, 300);
      },
      (error) => {
        Helpers.setLoading(false);
        console.log("GetTermsAndConditions", error);
      }
    );
  }

  PrintGatePass(data: any) {
    this.GatePassData = data || {};
    this.IsPrintGatePass = true;
    this.cdr.detectChanges();

    setTimeout(() => {
      const divElements = document.getElementById("PrintGatePass4x6");
      if (!divElements) {
        this.IsPrintGatePass = false;
        Helpers.setLoading(false);
        return;
      }

      const $iframe: any = $("<iframe id='GatePassPrintFrame'>").appendTo("body");
      const printDiv = `
        <html>
          <head>
            <title>Gate Pass</title>
            <style>
              @page { size: 4in 6in; margin: 0; }
              html, body { margin: 0; padding: 0; width: 4in; height: 6in; overflow: hidden; }
              body { font-family: Arial, Helvetica, sans-serif; color: #111; }
              * { box-sizing: border-box; }
            </style>
          </head>
          <body>${divElements.innerHTML}</body>
        </html>`;

      $iframe.contents().find("body").html(printDiv);
      const win = $iframe[0].contentWindow || $iframe[0];

      setTimeout(() => {
        win.focus();
        win.print();
        setTimeout(() => {
          $iframe.remove();
          this.IsPrintGatePass = false;
          Helpers.setLoading(false);
        }, 700);
      }, 300);
    }, 700);
  }

  getGatePassQrData() {
    const data = this.GatePassData || {};
    return [
      data.GatePassNo || "",
      data.VehicleNo || "",
      data.GateDate || "",
      data.GateInTime || "",
      data.ParkingNo || "",
      data.WHDockNo || "",
      data.DriverName || data.Driver || "",
      data.DriverMobileNo || "",
      data.GateType || "",
    ].join("|");
  }

  // Added by priya - 14/07/2026 - cn(PRIYA-JUL-009)
  PrintPalletSlip() {
    Helpers.setLoading(true);
    this.PalletSlipHeader = [];
    this.PalletSlipDetails = [];
    this._appService.GetByThreeId("OrdersByVehicle", "GetPalletSlipPrintData", this.OrderId, this.PalletNo || "", this.CompanyId).subscribe(
      (response) => {
        // this.PalletSlipHeader = response && response.Table && response.Table.length ? response.Table[0] : {};
        // this.PalletSlipDetails = response && response.Table1 ? response.Table1 : [];

        // if (!this.PalletSlipHeader || !this.PalletSlipHeader.PalletNo) {
        //   Helpers.setLoading(false);
        //   this.toastr.warning("No pallet data found for print");
        //   return;
        // }

        this.PalletSlipHeader = response && response.Table || [];
        for (const item of this.PalletSlipHeader) {
          item.ProductDetails = [];
          if (item.Product != null) {
            item.ProductDetails = JSON.parse(item.Product);
          }
        }

        if (!this.PalletSlipHeader.length) {
          Helpers.setLoading(false);
          this.toastr.warning("No pallet data found for print");
          return;
        }

        this.IsPrintPalletSlip = true;
        this.cdr.detectChanges();

        setTimeout(() => {
          const divElements = document.getElementById("PrintPalletSlip4x6");
          if (!divElements) {
            this.IsPrintPalletSlip = false;
            Helpers.setLoading(false);
            return;
          }

          const $iframe: any = $("<iframe id='PalletSlipPrintFrame'>").appendTo("body");
          
          // const printDiv = `<html><head><title>Pallet Slip</title>
          //                     <style>
          //                         @page{ size:4in 6in; margin:0;}
          //                         html,body{ margin:0;padding:0;width:4in;height:6in;overflow:hidden;background:#fff;}
          //                         body{font-family:"Arial Narrow",Arial,sans-serif;color:#050505;-webkit-print-color-adjust:exact;print-color-adjust:exact;}
          //                         *{box-sizing:border-box;}
          //                         #PrintPalletSlip4x6{width:495px;transform:scale(0.78);transform-origin:top left;}
          //                     </style></head><body>${divElements.outerHTML}</body></html>`;
          const printDiv = `
<html>
<head>
<title>Pallet Slip</title>

<style>

@page {
    size: 4in 6in;
    margin: 0;
}

html,
body {
    margin: 0 !important;
    padding: 0 !important;
    width: 4in;
    background: #fff;
}

body {
    font-family: Arial, sans-serif;
    color: #050505;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
}

* {
    box-sizing: border-box;
}

#PrintPalletSlip4x6 {
    width: 4in;
    margin: 0;
    padding: 0;
}

/*
 * ONE PALLET = ONE PRINT PAGE
 */
.pallet-print-page {
    width: 4in;
    height: 6in;

    margin: 0;
    padding: 0;

    position: relative;

    page-break-before: auto;
    page-break-after: always;

    break-before: auto;
    break-after: page;

    overflow: hidden;

    background: #fff;
}

/*
 * Don't create another page after the last pallet
 */
.pallet-print-page:last-child {
    page-break-after: auto;
    break-after: auto;
}

/*
 * Your original design is approximately 495px wide.
 * Scale it to fit 4 inch paper.
 */
.pallet-print-content {
    width: 495px;
    height: 742px;

    transform: scale(0.78);
    transform-origin: top left;

    overflow: hidden;
}

</style>

</head>

<body>

${divElements.outerHTML}

</body>
</html>
`;

          $iframe.contents().find("body").html(printDiv);
          const win = $iframe[0].contentWindow || $iframe[0];

          setTimeout(() => {
            win.focus();
            win.print();
            setTimeout(() => {
              $iframe.remove();
              this.IsPrintPalletSlip = false;
              Helpers.setLoading(false);
            }, 700);
          }, 300);
        }, 700);
      },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error("Error occurred while getting pallet print data", "error");
      }
    );
  }

  getPalletSkuTotal(skuCode: string) {
    return (this.PalletSlipDetails || [])
      .filter(x => x.SkuCode === skuCode)
      .reduce((total, item) => total + Number(item.Qty || 0), 0);
  }

  isFirstPalletSku(index: number) {
    const rows = this.PalletSlipDetails || [];
    return !index || !rows[index - 1] || rows[index - 1].SkuCode !== rows[index].SkuCode;
  }

  getPalletSkuRowSpan(skuCode: string) {
    return (this.PalletSlipDetails || []).filter(x => x.SkuCode === skuCode).length || 1;
  }

  getPalletSkuSrNo(index: number) {
    const rows = this.PalletSlipDetails || [];
    let srNo = 0;
    for (let i = 0; i <= index; i++) {
      if (!i || !rows[i - 1] || rows[i - 1].SkuCode !== rows[i].SkuCode) {
        srNo++;
      }
    }
    return srNo;
  }

  getPalletQrData() {
    const data = this.PalletSlipHeader || {};
    return [
      data.PalletNo || "",
      data.GRNNo || "",
      data.CustomerName || "",
      data.TotalQuantity || "",
      data.TotalGrossWeight || ""
    ].join("|");
  }
  // End by priya

}
